import React, { useState, useEffect } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import DigitalTransformationAssessment from './components/DigitalTransformationAssessment';
import DigitalTransformationDashboard from './components/DigitalTransformationDashboard';

function App() {
  const [activeView, setActiveView] = useState('assessment');
  const [assessmentId, setAssessmentId] = useState(null);
  const location = useLocation();
  const [canAccessDashboard, setCanAccessDashboard] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const accessKey = params.get('access');
    const secretKey = "amcepoakvfajgpsfjkpmwjec9waqjr0qjr;asmcl;zmcposzjf9weshf0WJKFOAPIOSCJF0JAX.G,PIJDGOIVJNSIPFJMWAEF,SDAFUNOISDHGUISDFNGOPXUJE.SOPKFOPAKFDOPSAHJFOIUSEHTOIJKAGOPMNGOISDFHGOIFDKMPBVLMCVXKBNISUFDHGIKMCGPS[J.KH,PIJSMIOBUYOTIBSEROHJGSFDIGO[GB DF";
    
    if (accessKey === secretKey) {
      setActiveView("dashboard");
      setCanAccessDashboard(true);
    }
  }, [location.search]);

  return (
    <div className="App">
      <header className="p-4 bg-blue-600 text-white">
        <div className="container mx-auto flex justify-between items-center">
          <h1 className="text-2xl font-bold">Digital Transformation Platform</h1>
        </div>
      </header>

      <main className="container mx-auto p-4">
        {canAccessDashboard && activeView === "dashboard" && (
          <DigitalTransformationDashboard
            onAssessmentSelect={setAssessmentId}
            selectedAssessmentId={assessmentId}
            onEditAssessment={(id) => {
              setAssessmentId(id);
              setActiveView('assessment');
            }}
          />
        )}
        {activeView === "assessment" && (
          <DigitalTransformationAssessment
            assessmentId={assessmentId}
            onSaveSuccess={(id) => {
              setAssessmentId(id);
              setActiveView('dashboard');
            }}
          />
        )}
      </main>
    </div>
  );
}

function AppWrapper() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}

export default AppWrapper;
